import { useAuth0 } from '@auth0/auth0-react';
import useSWRImmutable from 'swr/immutable';
import { JobCategory } from '@/Models/JobCategory';
import HttpError from '@/Utils/HTTP/Errors/HttpError';
import http from '@/Utils/HTTP/NewHttpUtils';

export interface JobFunctionsResponse {
    jobCategories: JobCategory[];
}

const DefaultJobFunctionsResponse: JobFunctionsResponse = {
    jobCategories: [],
};

export const useJobFunctions = () => {
    const { getAccessTokenSilently, isAuthenticated } = useAuth0();

    return useSWRImmutable(
        isAuthenticated ? 'job-functions' : null,
        async (path) => {
            const result = await http.get<JobFunctionsResponse>({
                path,
                accessToken: await getAccessTokenSilently(),
            });

            return result || DefaultJobFunctionsResponse;
        },
        {
            fallbackData: DefaultJobFunctionsResponse,
            // we need to reload configuration during sign up, because first call fails
            // with 403 because email is not verified yet
            shouldRetryOnError: (err) => err instanceof HttpError && err.status === 403,
        },
    );
};
